import DeliveryChoice from './DeliveryChoice';

export default DeliveryChoice;
